export default [
  {
    id: 1,
    name: {
      en: "meal reminders",
      nl: "maaltijd herinnering"
    }
    /* here we need a loop through moments and add descriptions/notification message */
  },
  {
    id: 2,
    name: {
      en: "positive vibes",
      nl: "opstekers"
    }
  },
  {
    id: 3,
    name: {
      en: "daily summary",
      nl: "dagelijkse samenvatting"
    }
  },
  {
    id: 4,
    name: {
      en: "weekly summary",
      nl: "wekelijkse samenvatting"
    }
  },
  {
    id: 5,
    name: {
      en: "messages from your buddy",
      nl: "berichten van je buddy"
    }
  }
];
